<template>
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.798 13.27V8.018H0.936V6.198H5.798V0.945999H7.696V6.198H12.558V8.018H7.696V13.27H5.798Z"
            fill="#6C6C6C"
        />
    </svg>
</template>
